import React, { FC } from 'react';
import { Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { SectionModel } from '../../../../../models/form/section';
import FormField from './field/FormField';

interface Props {
  section: SectionModel;
  fieldProperties: any;
  readOnlyMode?: boolean;
  addSection: (id: string) => void;
  removeSection: (id: string) => void;
}

const FormSectionMultiple: FC<Props> = ({
  section,
  fieldProperties,
  readOnlyMode,
  addSection,
  removeSection,
}: Props) => {
  let canDelete = true;
  let canAdd = true;
  if (section.sectionsFormik && section.multipleValidations) {
    if (section.multipleValidations.min) {
      if (section.multipleValidations.min >= section.sectionsFormik.length) {
        canDelete = false;
      }
    }
    if (section.multipleValidations.max) {
      if (section.multipleValidations.max <= section.sectionsFormik.length) {
        canAdd = false;
      }
    }
  }
  return (
    <React.Fragment>
      {section.sectionsFormik?.map((sec, index) => {
        return (
          <div
            style={{
              border: '2px dashed #ced4da',
              borderRadius: 8,
              padding: 8,
              marginBottom: 24,
              position: 'relative',
            }}
            key={sec.id}
          >
            <div className="d-flex justify-content-between">
              <div className="section-number" style={{ fontSize: 14, fontWeight: 600, color: '#2f438d', padding: 10 }}>
                #{index + 1}
              </div>
              {!readOnlyMode && canDelete && (
                <div>
                  <Button onClick={() => removeSection(sec.id)} variant="danger">
                    &times;
                  </Button>
                </div>
              )}
            </div>
            {sec.fields.map((field) => {
              return (
                <FormField
                  fieldProperties={fieldProperties}
                  readOnlyMode={readOnlyMode}
                  size={field.size}
                  field={field}
                  name={field.id}
                  key={field.id}
                />
              );
            })}
          </div>
        );
      })}
      {!readOnlyMode && canAdd && (
        <Button
          variant="link"
          style={{ marginBottom: 16, marginRight: 10 }}
          onClick={() => addSection(section.id)}
          disabled={readOnlyMode}
        >
          <FormattedMessage id="formList.buttons.addItem"></FormattedMessage>
        </Button>
      )}
    </React.Fragment>
  );
};

export default FormSectionMultiple;
